var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 51,
    viewBox: "0 0 173 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.19 50.9302H6.86331C3.29439 50.9302 0.490234 48.144 0.490234 44.598V6.60468C0.490234 3.05864 3.29439 0.272461 6.86331 0.272461H166.19C169.759 0.272461 172.563 3.05864 172.563 6.60468V44.598C172.563 48.0174 169.759 50.9302 166.19 50.9302Z",
    fill: "#0F1218"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.907 13.1903C60.907 14.2034 60.652 15.0899 60.0147 15.7231C59.25 16.483 58.3577 16.8629 57.2106 16.8629C56.0634 16.8629 55.1712 16.483 54.4064 15.7231C53.6417 14.9633 53.2593 14.0768 53.2593 12.937C53.2593 11.7972 53.6417 10.9107 54.4064 10.1508C55.1712 9.39092 56.0634 9.01099 57.2106 9.01099C57.7204 9.01099 58.2303 9.13763 58.7401 9.39092C59.25 9.64421 59.6323 9.8975 59.8873 10.2774L59.25 10.9107C58.7401 10.2774 58.1028 10.0241 57.2106 10.0241C56.4458 10.0241 55.681 10.2774 55.1712 10.9107C54.5339 11.4172 54.279 12.1771 54.279 13.0636C54.279 13.9501 54.5339 14.71 55.1712 15.2166C55.8085 15.7231 56.4458 16.1031 57.2106 16.1031C58.1028 16.1031 58.7401 15.8498 59.3774 15.2166C59.7598 14.8366 60.0147 14.3301 60.0147 13.6968H57.2106V12.8103H60.907C60.907 12.8103 60.907 13.0636 60.907 13.1903Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7702 10.0241H63.3288V12.4303H66.5153V13.3168H63.3288V15.7231H66.7702V16.7362H62.3091V9.13757H66.7702V10.0241Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9766 16.7362H69.9569V10.0241H67.79V9.13757H73.1434V10.0241H70.9766V16.7362Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8398 16.7362V9.13757H77.8595V16.7362H76.8398Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1929 16.7362H81.1732V10.0241H79.0063V9.13757H84.2323V10.0241H82.0654V16.7362H82.1929Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 15.723C93.5371 16.4829 92.6449 16.8628 91.4977 16.8628C90.3505 16.8628 89.4583 16.4829 88.6935 15.723C87.9288 14.9632 87.5464 14.0766 87.5464 12.9368C87.5464 11.797 87.9288 10.9105 88.6935 10.1507C89.4583 9.3908 90.3505 9.01086 91.4977 9.01086C92.6449 9.01086 93.5371 9.3908 94.3018 10.1507C95.0666 10.9105 95.449 11.797 95.449 12.9368C95.449 14.0766 95.0666 14.9632 94.3018 15.723ZM89.4583 15.0898C89.9682 15.5964 90.7329 15.9763 91.4977 15.9763C92.2625 15.9763 93.0272 15.723 93.5371 15.0898C94.0469 14.5832 94.4293 13.8234 94.4293 12.9368C94.4293 12.0503 94.1744 11.2905 93.5371 10.7839C93.0272 10.2773 92.2625 9.89738 91.4977 9.89738C90.7329 9.89738 89.9682 10.1507 89.4583 10.7839C88.9485 11.2905 88.5661 12.0503 88.5661 12.9368C88.5661 13.8234 88.821 14.5832 89.4583 15.0898Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8511 16.7362V9.13757H97.9982L101.695 15.0899V13.5701V9.13757H102.714V16.7362H101.695L97.7433 10.5307V12.0504V16.7362H96.8511Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2915 27.8809C84.2325 27.8809 81.8107 30.1605 81.8107 33.3266C81.8107 36.366 84.2325 38.7723 87.2915 38.7723C90.3506 38.7723 92.7724 36.4927 92.7724 33.3266C92.7724 30.0338 90.3506 27.8809 87.2915 27.8809ZM87.2915 36.4927C85.6345 36.4927 84.2325 35.0996 84.2325 33.1999C84.2325 31.3003 85.6345 29.9072 87.2915 29.9072C88.9485 29.9072 90.3506 31.1736 90.3506 33.1999C90.3506 35.0996 88.9485 36.4927 87.2915 36.4927ZM75.4376 27.8809C72.3786 27.8809 69.9568 30.1605 69.9568 33.3266C69.9568 36.366 72.3786 38.7723 75.4376 38.7723C78.4967 38.7723 80.9185 36.4927 80.9185 33.3266C80.9185 30.0338 78.4967 27.8809 75.4376 27.8809ZM75.4376 36.4927C73.7806 36.4927 72.3786 35.0996 72.3786 33.1999C72.3786 31.3003 73.7806 29.9072 75.4376 29.9072C77.0946 29.9072 78.4967 31.1736 78.4967 33.1999C78.4967 35.0996 77.0946 36.4927 75.4376 36.4927ZM61.2894 29.5272V31.8068H66.7703C66.6428 33.0733 66.1329 34.0864 65.4956 34.7197C64.7309 35.4795 63.4563 36.366 61.2894 36.366C57.848 36.366 55.2987 33.7065 55.2987 30.2871C55.2987 26.8677 57.9754 24.2082 61.2894 24.2082C63.0739 24.2082 64.4759 24.9681 65.4956 25.8546L67.1526 24.2082C65.7506 22.9417 63.9661 21.9286 61.4169 21.9286C56.8283 21.9286 52.877 25.7279 52.877 30.2871C52.877 34.8463 56.8283 38.6456 61.4169 38.6456C63.9661 38.6456 65.7506 37.8858 67.2801 36.2394C68.8096 34.7197 69.3195 32.5667 69.3195 30.9203C69.3195 30.4138 69.3195 29.9072 69.192 29.5272H61.2894ZM119.157 31.3003C118.647 30.0338 117.372 27.8809 114.568 27.8809C111.764 27.8809 109.47 30.0338 109.47 33.3266C109.47 36.366 111.764 38.7723 114.823 38.7723C117.245 38.7723 118.775 37.2526 119.284 36.366L117.5 35.0996C116.863 35.9861 116.098 36.6193 114.823 36.6193C113.549 36.6193 112.784 36.1128 112.147 34.973L119.412 31.9335L119.157 31.3003ZM111.764 33.0733C111.764 31.047 113.421 29.9072 114.568 29.9072C115.461 29.9072 116.353 30.4138 116.608 31.047L111.764 33.0733ZM105.773 38.2657H108.195V22.4352H105.773V38.2657ZM101.95 29.0207C101.312 28.3875 100.293 27.7542 99.018 27.7542C96.3413 27.7542 93.7921 30.1605 93.7921 33.1999C93.7921 36.2394 96.2139 38.519 99.018 38.519C100.293 38.519 101.312 37.8858 101.822 37.2526H101.95V38.0124C101.95 40.0387 100.802 41.1785 99.018 41.1785C97.6159 41.1785 96.5962 40.1654 96.3413 39.2789L94.3019 40.1654C94.9392 41.5585 96.4688 43.3315 99.1455 43.3315C101.95 43.3315 104.244 41.6851 104.244 37.7591V28.1342H101.95V29.0207ZM99.1455 36.4927C97.4885 36.4927 96.0864 35.0996 96.0864 33.1999C96.0864 31.3003 97.4885 29.9072 99.1455 29.9072C100.802 29.9072 102.077 31.3003 102.077 33.1999C102.077 35.0996 100.802 36.4927 99.1455 36.4927ZM130.246 22.4352H124.51V38.2657H126.932V32.3134H130.246C132.923 32.3134 135.472 30.4138 135.472 27.3743C135.472 24.3348 132.923 22.4352 130.246 22.4352ZM130.374 30.0338H126.932V24.5881H130.374C132.158 24.5881 133.178 26.1079 133.178 27.2476C133.05 28.6407 132.031 30.0338 130.374 30.0338ZM145.032 27.7542C143.247 27.7542 141.463 28.5141 140.825 30.1605L142.992 31.047C143.502 30.1605 144.267 29.9072 145.159 29.9072C146.434 29.9072 147.581 30.667 147.708 31.9335V32.0601C147.326 31.8068 146.306 31.4269 145.286 31.4269C142.992 31.4269 140.698 32.6934 140.698 34.973C140.698 37.1259 142.61 38.519 144.649 38.519C146.306 38.519 147.071 37.7591 147.708 36.9993H147.836V38.2657H150.13V32.1868C149.875 29.4006 147.708 27.7542 145.032 27.7542ZM144.777 36.4927C144.012 36.4927 142.865 36.1128 142.865 35.0996C142.865 33.8332 144.267 33.4532 145.414 33.4532C146.434 33.4532 146.944 33.7065 147.581 33.9598C147.326 35.4795 146.051 36.4927 144.777 36.4927ZM158.16 28.1342L155.483 34.973H155.356L152.552 28.1342H150.003L154.209 37.7591L151.787 43.0782H154.209L160.709 28.1342H158.16ZM136.747 38.2657H139.168V22.4352H136.747V38.2657Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7462 9.77087C13.3638 10.1508 13.1089 10.784 13.1089 11.5439V39.5323C13.1089 40.2922 13.3638 40.9254 13.7462 41.3053L13.8737 41.432L29.6789 25.7281V25.6014V25.4748L13.7462 9.77087Z",
    fill: "url(#paint0_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9046 31.0469L29.6787 25.8545V25.6012V25.4745L34.9046 20.2821L35.0321 20.4087L41.2777 23.9548C43.0622 24.9679 43.0622 26.6143 41.2777 27.6275L34.9046 31.0469Z",
    fill: "url(#paint1_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0322 30.9204L29.6788 25.6013L13.7461 41.4319C14.3834 42.0651 15.2756 42.0651 16.4228 41.5585L35.0322 30.9204Z",
    fill: "url(#paint2_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0322 20.282L16.4228 9.77056C15.2756 9.13734 14.3834 9.26398 13.7461 9.8972L29.6788 25.6011L35.0322 20.282Z",
    fill: "url(#paint3_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.9047 30.7936L16.4228 41.1784C15.4031 41.8116 14.5109 41.685 13.8736 41.1784L13.7461 41.3051L13.8736 41.4317C14.5109 41.9383 15.4031 42.0649 16.4228 41.4317L34.9047 30.7936Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M13.7452 41.1784C13.3628 40.7985 13.2354 40.1653 13.2354 39.4054V39.532C13.2354 40.2919 13.4903 40.9251 13.8727 41.3051V41.1784H13.7452Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M41.2779 27.2477L34.9048 30.7937L35.0322 30.9204L41.2779 27.3743C42.1701 26.8678 42.5525 26.2345 42.5525 25.6013C42.5525 26.2345 42.0426 26.7411 41.2779 27.2477Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M16.4219 9.89734L41.2769 23.9549C42.0416 24.4614 42.5515 24.968 42.5515 25.6012C42.5515 24.968 42.1691 24.3348 41.2769 23.8282L16.4219 9.7707C14.6374 8.75754 13.2354 9.64405 13.2354 11.6704V11.797C13.2354 9.7707 14.6374 8.88419 16.4219 9.89734Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.2764,
    y1: 11.3029,
    x2: 7.02289,
    y2: 32.6935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.6158,
    y1: 25.6029,
    x2: 12.7741,
    y2: 25.6029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 32.135,
    y1: 28.5092,
    x2: 3.31345,
    y2: 57.5167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.79135,
    y1: 0.495378,
    x2: 22.6614,
    y2: 13.4484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/googlePlay_icon.c6c925db00c77ff6f86dd2b2dbaf8f9b.svg";
export { ForwardRef as ReactComponent };